import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { api } from "../../lib/api";
import { fcfa } from "./DemosPipeline";

const moisFr = (ym) => new Date(`${ym}-01T00:00:00`).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
const Kpi = ({ label, value, hint, testid }) => (
  <div className="rounded-xl border border-[#7DC4E8] bg-white p-3" data-testid={testid}>
    <p className="text-[11px] font-semibold uppercase tracking-wider text-[#0369A1]">{label}</p>
    <p className="mt-0.5 font-display text-xl font-bold text-[#0C4A6E]">{value}</p>
    {hint && <p className="text-[11px] text-slate-500">{hint}</p>}
  </div>
);

export function BilanCommercial({ refreshKey }) {
  const [month, setMonth] = useState("");
  const [b, setB] = useState(null);
  useEffect(() => { api.get("/admin/demos/bilan", { params: month ? { month } : {} }).then(({ data }) => setB(data)).catch(() => setB(null)); }, [month, refreshKey]);
  if (!b) return null;
  return (
    <div className="mt-4 rounded-2xl border border-[#7DC4E8] bg-[#F0F9FF] p-4" data-testid="bilan-commercial">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="font-display text-base font-bold text-navy">Bilan commercial</p>
        <select value={b.month} onChange={(e) => setMonth(e.target.value)} data-testid="bilan-month" className="rounded-full border border-[#7DC4E8] bg-white px-3 py-1 text-sm capitalize">
          {b.mois_disponibles.map((m) => <option key={m} value={m}>{moisFr(m)}</option>)}
        </select>
      </div>
      <div className="mt-3 grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
        <Kpi label="Demandes du mois" value={b.demandes} hint={`${b.perdus} perdue${b.perdus > 1 ? "s" : ""}`} testid="bilan-demandes" />
        <Kpi label="Devis en cours" value={fcfa(b.devis_en_cours.montant)} hint={`${b.devis_en_cours.nombre} devis à l'étape « Devis envoyé »`} testid="bilan-devis-en-cours" />
        <Kpi label="Devis émis ce mois" value={fcfa(b.devis_emis_mois.montant)} hint={`${b.devis_emis_mois.nombre} devis`} testid="bilan-devis-emis" />
        <Kpi label="Contrats signés ce mois" value={fcfa(b.signes_mois.montant)} hint={`${b.signes_mois.nombre} contrat${b.signes_mois.nombre > 1 ? "s" : ""}`} testid="bilan-signes" />
        <Kpi label="Demande → contrat" value={`${String(b.taux_global).replace(".", ",")} %`} hint="demandes du mois signées" testid="bilan-taux-global" />
      </div>
      <div className="mt-3 flex flex-wrap items-stretch gap-2" data-testid="bilan-passages">
        {b.passages.map((p) => (
          <div key={p.de} className="flex min-w-[150px] flex-1 items-center gap-2 rounded-xl bg-white px-3 py-2 text-xs" data-testid={`bilan-passage-${p.de}`}>
            <div className="flex-1"><p className="text-slate-500">{p.de_label} <ArrowRight size={11} className="inline" /> {p.vers_label}</p>
              <p className="font-display text-lg font-bold text-[#0369A1]">{String(p.taux).replace(".", ",")} %</p><p className="text-slate-400">{p.passes}/{p.entres}</p></div>
          </div>
        ))}
      </div>
    </div>
  );
}
